module.exports = "./img/f364d5c65abac58274a727e41c72dfd3.png";